import React from 'react'
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import FormTitle from '../../../library/form/components/FormTitle';

const ProfileBankEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{height: '200px'}}
            formStyle={{ width: '640px' }} formTitle={<FormTitle formObject={formObject} value="Profile Address" />} 
        >
            <ul className="uiHeaderTwoCol">
                <li>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "accNum" }} value="Account Number" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" autofocus className="uiInput" id="contactTxt"
                            action={{ InputType: "input", paramName: "accNum" }}
                        />
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "accName" }} value="Account Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" id="contactTxt"
                            action={{ InputType: "input", paramName: "accName" }}
                        />
                    </div>
                </li>
                <li>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bankName" }} value="Bank Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" id="contactTxt"
                            action={{ InputType: "input", paramName: "bankName" }}
                        />
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bankCity" }} value="Bank City" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" id="contactTxt"
                            action={{ InputType: "input", paramName: "bankCity" }}
                        />
                    </div>
                </li>
                <li>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bankBranch" }} value="Bank Branch" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" id="contactTxt"
                            action={{ InputType: "input", paramName: "bankBranch" }}
                        />
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bankAddress" }} value="Bank Address" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" id="contactTxt"
                            action={{ InputType: "input", paramName: "bankAddress" }}
                        />
                    </div>
                </li>
                <li>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chequeFavorTo" }} value="Cheque Favouring" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" id="contactTxt"
                            action={{ InputType: "input", paramName: "chequeFavorTo" }}
                        />
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="" rows="3" cols="82"
                            action={{ paramName: "remarks" }}
                        />
                    </div>
                </li>
            </ul>
        </FormDialog>
    )
}

export default withView(ProfileBankEditor, "proBank", "proBank")